/**
 * ADMIN MODULE — Support Tickets
 * Cross-tenant support inbox (Brand Command staff only). Renders the AdminTickets
 * grid/thread UI inside the admin shell so it carries the admin sidebar nav and
 * the RequireSuperAdmin gate from the module route.
 */

import AdminLayout from "../components/AdminLayout.jsx";
import AdminTickets from "../components/AdminTickets.jsx";

export default function SupportTicketsView() {
  return (
    <AdminLayout title="Support Tickets" subtitle="Cross-tenant support inbox — every ticket across tenants.">
      <AdminTickets />
    </AdminLayout>
  );
}
